import React, { useState } from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { Search, BookOpen, User, LogOut, Menu, X } from 'lucide-react';
import { useAuthStore } from '../../store/auth';

export default function OpacLayout() {
  const [q, setQ] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();
  const opacUser = JSON.parse(localStorage.getItem('opac_user') || 'null');
  const isLoggedIn = !!localStorage.getItem('opac_token');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (q.trim()) navigate(`/opac/catalog?q=${encodeURIComponent(q)}`);
  };

  return (
    <div style={{minHeight:'100vh',background:'#060a12',color:'#e2e8f0',fontFamily:'system-ui,sans-serif'}}>
      <header style={{background:'#0a1628',borderBottom:'1px solid #1e2d45',position:'sticky',top:0,zIndex:100}}>
        <div style={{maxWidth:1200,margin:'0 auto',padding:'0 20px',height:64,display:'flex',alignItems:'center',gap:20}}>
          <Link to="/opac" style={{display:'flex',alignItems:'center',gap:10,textDecoration:'none',flexShrink:0}}>
            <img src="/logo.svg" alt="Folios" style={{width:36,height:36,borderRadius:8}} />
            <div>
              <div style={{fontSize:15,fontWeight:700,color:'#f1f5f9'}}>Folios</div>
              <div style={{fontSize:10,color:'#475569'}}>ონლაინ კატალოგი</div>
            </div>
          </Link>

          <form onSubmit={handleSearch} style={{flex:1,maxWidth:560,position:'relative'}}>
            <Search size={16} style={{position:'absolute',left:14,top:'50%',transform:'translateY(-50%)',color:'#475569'}} />
            <input value={q} onChange={e => setQ(e.target.value)}
              placeholder="მოძებნე წიგნი, ავტორი, ISBN..."
              style={{width:'100%',background:'#111827',border:'1px solid #1e2d45',borderRadius:24,padding:'10px 16px 10px 44px',fontSize:14,color:'#e2e8f0',outline:'none',boxSizing:'border-box'}} />
          </form>

          <nav style={{display:'flex',alignItems:'center',gap:4,marginLeft:'auto'}}>
            <Link to="/opac/catalog" style={{padding:'8px 14px',borderRadius:8,fontSize:13,color:'#94a3b8',textDecoration:'none'}}>კატალოგი</Link>
            {isLoggedIn ? (
              <>
                <Link to="/opac/my" style={{display:'flex',alignItems:'center',gap:5,padding:'8px 14px',borderRadius:8,fontSize:13,color:'#94a3b8',textDecoration:'none'}}>
                  <User size={15}/> ჩემი
                </Link>
                <button onClick={() => { logout(); navigate('/opac'); window.location.href='/opac'; }}
                  style={{display:'flex',alignItems:'center',gap:5,padding:'8px 12px',background:'none',border:'none',borderRadius:8,fontSize:13,color:'#475569',cursor:'pointer'}}>
                  <LogOut size={15}/>
                </button>
              </>
            ) : (
              <Link to="/opac/login" style={{display:'flex',alignItems:'center',gap:5,padding:'8px 16px',background:'#1d4ed8',borderRadius:8,fontSize:13,color:'white',textDecoration:'none',fontWeight:500}}>
                <User size={15}/> შესვლა
              </Link>
            )}
          </nav>
        </div>
      </header>

      <main style={{maxWidth:1200,margin:'0 auto',padding:'0 20px'}}>
        <Outlet />
      </main>

      <footer style={{borderTop:'1px solid #1e2d45',padding:'24px 20px',textAlign:'center',marginTop:48}}>
        <p style={{fontSize:12,color:'#334155'}}>© 2026 Kakhaber Revazishvili · SANGU · Folios Library System</p>
      </footer>
    </div>
  );
}
